module.exports = __webpack_public_path__ + "static/media/11NEPAD12.2b6ba539.jpg";